import "./ScrollbarThumb.styles.scss";

const RenderHorizontalThumb: React.FC = (props: any) => {
    const thumbStyle = {
        borderRadius: "20px",
        zIndex: 200,
    };
    return (
        <div
            {...props}
            style={{ ...props.style, ...thumbStyle }}
            className="ScrollbarThumb is-horizontal"
        />
    );
};

export default RenderHorizontalThumb;